import { Store, applyMiddleware, compose, createStore } from 'redux';
import { History } from 'history';
import createSagaMiddleware from 'redux-saga';
import history from '../services/history';
import reducers from './reducers';
import { routerMiddleware } from 'connected-react-router';
import sagas from './sagas';

function configureStore(initialState = {}, history: History): Store {
    let composeEnhancers = compose;
    const reduxSagaMonitorOptions = {};

    if (process.env.NODE_ENV !== 'production' && typeof window === 'object') {
        // @ts-ignore
        if (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) {
            // @ts-ignore
            composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({});
        }
        // uncomment when https://github.com/abettadapur/redux-saga-devtools-extension/issues/6 will be resolved
        // @ts-ignore
        // if (window.__SAGA_MONITOR_EXTENSION__) {
        //     reduxSagaMonitorOptions = {
        //         // @ts-ignore
        //         sagaMonitor: window.__SAGA_MONITOR_EXTENSION__,
        //     };
        // }
    }

    const sagaMiddleware = createSagaMiddleware(reduxSagaMonitorOptions);

    const middlewares = [sagaMiddleware, routerMiddleware(history)];
    const enhancers = [applyMiddleware(...middlewares)];
    const store = createStore(reducers(history), initialState, composeEnhancers(...enhancers));

    sagaMiddleware.run(sagas);

    return store;
}

const store = configureStore({}, history);

export default store;
